import React from "react";

function Credits() {
	return (
		<div className="flex items-center pt-[100px]">
			<div className="text-center text-rosePine-text w-[100%] text-[16px] pb-[40px]">
				<div>Built and designed by Hyun.</div>
				<div>All rights reserved. ©</div>
				<div></div>
			</div>
		</div>
	);
}

export default Credits;
